// extracted by mini-css-extract-plugin
module.exports = {"detailWrap":"punch-detail_detailWrap_3RnHc"};